import type { FaireProductEntity } from "../../entity_types/product";

export const p_ntkqykdmgj: FaireProductEntity = {
  token: "p_ntkqykdmgj",
  type: "product",
  name: "birds watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/bba146af559759bb6a3e2c90048df4f35e4d97607fac65455f839dd6f34f36e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc5b350257b2e0afdb884f5ee8c0102f9d44d109c2be9f3149cba33e05682c56.jpeg",
    "https://cdn.faire.com/fastly/8b85373b2eb6aeda06b28b40669aff14f2836be68073ca5ad2de17183cb37fb8.jpeg",
    "https://cdn.faire.com/fastly/d525ead54a26780a88eeb1f9c12e9865a2934512f47524e572aef53ec85ab743.jpeg",
    "https://cdn.faire.com/fastly/7458c380157f39ec7a0d71d69f182d5b3cdf1c958d42fafc2d5656cce623884a.jpeg",
    "https://cdn.faire.com/fastly/896452a89d744ec0068f33797eb350f109202d8c8087cb77a39725097b1c728a.jpeg",
    "https://cdn.faire.com/fastly/6dffca5a57a703d7f5b4765725cbd22d092b8efd5a78d47e2fdfb506c2f547f6.jpeg",
    "https://cdn.faire.com/fastly/89046cf44279731b175d21559b8231f98145d068009228da43860e32f1c79844.jpeg",
    "https://cdn.faire.com/fastly/a1327313495343047ec99ac403d81cb91fbc47460370d60322b2af5ed759cd8f.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve backyard birds — a wren, hummingbird, bluebird, cardinal, chickadee, goldfinch, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA favorite for nature lovers and birdwatchers. Performs well in gift shops, garden boutiques, and as a Father's Day or grandparent gift.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:09.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
